/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  LinearProgress,
  makeStyles
} from '@material-ui/core'
import axios from 'axios'
import { differenceInDays } from 'date-fns'
import moment from 'moment'
import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { DateStringFormatToBr } from '../../helpers/DateStringFormat'

import searchIcon from '../../assets/images/search.svg'
import PaginationComponent from '../../components/PaginationComponent'
import ToastMessages from '../../components/ToastMessages'
import TopSearch from '../../components/TopSearch'
import Context from '../../context'
import { getMovieTicketsOrder, getSearch } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import { reversalPayment, sendEmailMovierOrderPending } from '../../services/graphqlApi'
import history from '../../services/history'

function MovieTicketsPurchases() {
  const classes = useStyles()
  const { setUser } = useContext(Context)
  const { setAboutCurrentPage } = useContext(Context)
  const [searchData, setSearchData] = useState({ str: '', startSearch: false })
  const [page, setPage] = useState(0)
  const [totalPages, setTotalPages] = useState(5)
  const [fullOrders, setFullOrders] = useState([])
  const [finalData, setFinalData] = useState(null)
  const [userData, setUserData] = useState([])
  const [loading, setLoading] = useState(false)
  const [userModalData, setUserModalData] = useState(null)
  const [reversalModal, setReversalModal] = useState(false)
  const [contactModal, setContactModal] = useState(false)
  const [orderId, setOrderId] = useState(false)
  const [urlBoleto, setUrlBoleto] = useState(null)

  const listUpdate = async () => {
    setLoading(true)
    const actualPage = page || 1
    return getMovieTicketsOrder(actualPage, 16)
  }
  const sendEmailPeding = async order => {
    setLoading(true)
    sendEmailMovierOrderPending(order)
      .then(res => {
        listUpdate()
          .then(response => {
            const { pagination } = response
            setFullOrders(response.data)
            setFinalData(response.data)
            setPage(pagination.page || 1)
            setTotalPages(pagination.totalPages || 1)
            setLoading(false)
          })
          .catch(error => {
            console.log('error', error)
          })
      })
      .catch(error => {
        console.log('error', error)
      })
  }

  const reversalMovieTicket = async () => {
    setLoading(true)
    reversalPayment(orderId)
      .then(res => {
        console.log(res)
        listUpdate()
          .then(response => {
            const { pagination } = response
            setFullOrders(response.data)
            setFinalData(response.data)
            setPage(pagination.page || 1)
            setTotalPages(pagination.totalPages || 1)
            setLoading(false)
          })
          .catch(error => {
            console.log('error', error)
          })
      })
      .catch(error => {
        console.log('error', error)
      })
  }

  useEffect(() => {
    if (!isAuthenticated) return history.replace('/')
    setUser(getLoggedUser)
    setAboutCurrentPage({
      title: 'Ingressos vendidos',
      buttons: [
        {
          title: 'Voltar',
          pathname: '/movieticketslist'
        }
      ]
    })
    listUpdate()
      .then(res => {
        const { pagination } = res
        setFullOrders(res.data)
        // setFinalData(res.data);
        setPage(pagination.page || 1)
        setTotalPages(pagination.totalPages || 1)
        setLoading(false)
      })
      .catch(error => {
        console.log('error', error)
      })
  }, [])

  useEffect(() => {
    if (searchData.startSearch) {
      setLoading(true)
      getSearch('movieTicketsOrder', searchData.str).then(r => {
        setFinalData(r)
        console.log(r)
        setSearchData({ ...searchData, startSearch: false })
        setLoading(false)
      })
    }

    if (!searchData.startSearch && searchData.str === '') {
      setFinalData(fullOrders)
    }
  }, [searchData])

  useEffect(() => {
    listUpdate().then(r => {
      const { data } = r

      setFullOrders(data)
      setLoading(false)
    })
  }, [page])

  useEffect(() => {
    if (fullOrders && fullOrders.length > 0) {
      setFinalData(fullOrders)
    }
  }, [fullOrders])

  async function getUserGazeta(userId) {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        'x-publisher-id': '94e6bf84-f14c-11e7-8c3f-9a214cf093ae'
      }
    }
    let responseGazeta = await axios
      .get(`https://account-api.gazetadopovo.com.br/users?id=${userId}`, options)
      .catch(() => ({ data: {} }))
    responseGazeta = responseGazeta.data
    setUserData({
      email: responseGazeta.users[0].Emails[0]?.email,
      phone: responseGazeta.users[0].Phones[0]?.phone,
      ...responseGazeta.users[0]
    })
  }

  function formatNumber(value) {
    return value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    })
  }

  function hideUserModalData() {
    setUserModalData(false)
  }
  function hideUReversalModal() {
    setReversalModal(false)
  }
  function hideContactModal() {
    setContactModal(false)
  }

  function compareDates(date) {
    const result = differenceInDays(new Date(), new Date(date))
    return result
  }
  function convertDateToHours(date) {
    const timezone = 'America/Sao_Paulo'
    const newDate = new Date(date)
    const teste = moment(newDate, 'HHmmss', timezone)
    const result = teste.format('HH:mm:ss')
    return result
  }

  return (
    <>
      <div className={classes.outerContainer}>
        <div className={classes.content}>
          <Grid item xs={12}>
            <ToastMessages />
            <Context.Provider value={{ searchData, setSearchData }}>
              <TopSearch
              // searchAction={handleSearch}
              // showFilter
              // filterAction={handleSelectFilter}
              />
            </Context.Provider>
          </Grid>
          <table className={classes.table}>
            <colgroup>
              <col />
              <col className={classes.fitContent} />
              <col className={classes.fitContent} />
              <col className={classes.fitContent} />
              <col className={classes.fitContent} />
            </colgroup>
            <thead>
              <tr>
                <td>Data e Hora</td>
                <td>Pedido</td>
                <td>Cliente</td>
                <td>Situação de pagamento</td>
                <td>Forma de pagamento</td>
                <td>Valor total</td>
                <td>Vouchers</td>
                <td />
              </tr>
            </thead>
            <tbody>
              {!loading &&
                finalData?.map(item => (
                  <tr>
                    <td className={classes.titleContainer}>
                      {DateStringFormatToBr(item.createdAt)}
                      <br />
                      {convertDateToHours(item.createdAt)}
                    </td>
                    <td>{item.id}</td>
                    <td>
                      <Link>
                        <a
                          onClick={() => {
                            setUserModalData(true)
                            if (item.clientGazetaId !== null) {
                              getUserGazeta(item.clientGazetaId)
                              setUserData(item.ClientGazetum)
                            } else {
                              setUserData({
                                name: item.name,
                                cpf: item.cpf,
                                email: item.email,
                                phone: item.phone,
                                id: ''
                              })
                            }
                          }}
                        >
                          {item.clientGazetaId !== null ? (
                            item.clientGazetaId
                          ) : (
                            <>
                              <p>Nome: {item.name}</p>
                              <p>CPF: {item.cpf}</p>
                            </>
                          )}
                        </a>
                      </Link>
                    </td>
                    <td className={classes.quantityContainer}>
                      <div>
                        {item.paymentSituation === 'PENDENTE' ? (
                          <Link>
                            <a
                              onClick={() => {
                                sendEmailPeding(item.id)
                              }}
                            >
                              <p className={classes.paymentSituationPendente}>
                                {item.paymentSituation}
                              </p>
                            </a>
                          </Link>
                        ) : (
                          <p className={classes.paymentSituationPago}>{item.paymentSituation}</p>
                        )}
                      </div>
                    </td>
                    <td>{item.paymentMethod}</td>
                    <td>{formatNumber(item.value)}</td>
                    <td>
                      <div className={classes.voucherText}>
                        {item.MovieTicket?.MovieTicketsGroup?.Partner?.fantasyName ? (
                          <p>
                            {`${
                              item.MovieTicket?.MovieTicketsGroup?.Partner?.fantasyName
                            }: ${item.MovieTicket?.code?.toUpperCase()}`}
                          </p>
                        ) : null}
                      </div>
                    </td>
                    <td>
                      {compareDates(item.createdAt) <= 30 && item.paymentSituation === 'PAGO' ? (
                        <div className={classes.estornContainer}>
                          <Button
                            className={classes.reverseButton}
                            color="primary"
                            onClick={() => {
                              window.open('')
                              setReversalModal(true)
                              setOrderId(item.id)
                            }}
                          >
                            Estornar
                          </Button>
                        </div>
                      ) : (
                        <>
                          {JSON.parse(item?.logGateway) ? (
                            <div className={classes.paymentOptionsContainer}>
                              <Button
                                className={classes.paymentButton}
                                color="primary"
                                onClick={() => {
                                  window.open(JSON.parse(item?.logGateway).secure_url)
                                }}
                              >
                                Boleto
                              </Button>
                              <Button
                                className={classes.contactButton}
                                color="primary"
                                onClick={() => {
                                  getUserGazeta(item.clientGazetaId)
                                  setContactModal(true)
                                  setUserData(item.ClientGazetum)
                                  setUrlBoleto(JSON.parse(item?.logGateway).secure_url)
                                }}
                              >
                                WhatsApp
                              </Button>
                            </div>
                          ) : null}
                        </>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {loading ? <LinearProgress style={{ marginTop: 30 }} /> : null}
        </div>
      </div>

      <Dialog
        open={!!userModalData}
        onClose={!hideUserModalData}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Dados do cliente</DialogTitle>
        <DialogContent>
          <DialogContentText>{`ID: ${userData?.id ? userData?.id : ''}`}</DialogContentText>
          <DialogContentText>{`Nome: ${userData?.name ? userData?.name : ''}`}</DialogContentText>
          <DialogContentText>{`CPF: ${userData?.cpf ? userData?.cpf : ''}`}</DialogContentText>
          <DialogContentText>{`Email: ${
            userData?.email ? userData?.email : ''
          }`}</DialogContentText>
          <DialogContentText>{`Telefone: ${
            userData?.phone ? userData?.phone : ''
          }`}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => {
              setUserData(null)
              hideUserModalData()
            }}
          >
            Voltar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={!!reversalModal}
        onClose={!hideUReversalModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Você tem certeza que deseja estornar a compra ?</DialogTitle>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => {
              setReversalModal(false)
              reversalMovieTicket()
            }}
          >
            Sim
          </Button>
          <Button
            color="primary"
            onClick={() => {
              setReversalModal(false)
            }}
          >
            Não
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={!!contactModal}
        onClose={!hideContactModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Enviar boleto via WhatsApp</DialogTitle>
        <DialogContent>
          {/* <DialogContentText>{`ID: ${userData?.id}`}</DialogContentText> */}
          <DialogContentText>{`Nome: ${
            userData?.name ? userData?.name : 'Nome não cadastrado'
          }`}</DialogContentText>
          {/* <DialogContentText>{`CPF: ${userData?.cpf}`}</DialogContentText> */}
          {/* <DialogContentText>{`Email: ${userData?.email}`}</DialogContentText> */}
          <DialogContentText>{`Telefone: ${
            userData?.phone ? userData?.phone : 'Número não cadastrado'
          }`}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => {
              setUserData(null)
              hideContactModal()
            }}
          >
            Voltar
          </Button>
          {userData?.phone ? (
            <Button
              color="primary"
              onClick={() => {
                setUserData(null)
                hideContactModal()
                window.open(
                  `https://api.whatsapp.com/send?phone=55${userData?.phone}&text=Segue%20seu%20link%20para%20pagamento%20dos%20ingressos%20comprados%20no%20Zet%3A%20${urlBoleto}`
                )
                // window.open(
                //   `https://api.whatsapp.com/send?phone=${userData?.phone}`
                // );
              }}
            >
              Enviar
            </Button>
          ) : null}
        </DialogActions>
      </Dialog>
      <Grid item xs={12}>
        <Context.Provider value={{ page, setPage, totalPages }}>
          <PaginationComponent />
        </Context.Provider>
      </Grid>
    </>
  )
}

const useStyles = makeStyles({
  voucherText: {
    maxWidth: '16em',
    whiteSpace: 'normal'
  },
  reverseButton: {
    backgroundColor: '#FECE44'
  },
  paymentButton: {
    backgroundColor: '#FF0000',
    marginBottom: '0.7em',
    marginTop: '0.7em'
  },
  contactButton: {
    backgroundColor: '#32CD32'
  },
  paymentSituationPago: {
    color: '#32CD32',
    fontFamily: 'Montserrat',
    fontWeight: '700'
  },
  paymentSituationPendente: {
    color: '#FF0000',
    fontFamily: 'Montserrat',
    fontWeight: '700'
  },
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Montserrat',
    fontWeight: '500'
  },
  row: {
    display: 'flex',
    flexDirection: 'row'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: '40px 45px'
  },
  filters: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: 40,
    marginRight: 30,
    padding: '12px 10px 10px',
    borderBottom: '2px solid #30287b'
  },
  sorting: {
    height: '100%',
    fontSize: '12px',
    color: '#30287b',
    border: 'none',
    '& option:disabled': {
      display: 'none'
    }
  },
  search: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    width: 190,
    height: 40,
    padding: '10px 15px',
    boxSizing: 'border-box',
    fontSize: '12px',
    color: '#30287b',
    background: `url(${searchIcon}) top right / auto 100% content-box no-repeat`,
    border: '2px solid #30287b'
  },
  table: {
    marginTop: '20px',
    whiteSpace: 'nowrap',
    border: '2px solid #30287b',
    '& td': {
      border: '2px solid #30287b'
    },
    '& thead': {
      background: '#30287b'
    },
    '& thead td': {
      fontSize: '12px',
      padding: '17px 25px',
      fontWeight: '700',
      color: '#ffffff',
      lineHeight: '13px',
      textTransform: 'uppercase'
    },
    '& tbody td': {
      fontSize: '14px',
      padding: '17px 25px',
      color: '#30287b'
    }
  },
  fitContent: {
    width: 'fit-content'
  },
  titleContainer: {
    '& div:first-child': {
      marginBottom: '17px',
      fontWeight: '700'
    },
    '& div:last-child': {
      fontSize: '12px',
      '& a': {
        cursor: 'pointer'
      },
      '& a:not(:last-child)': {
        color: '#30287b'
      },
      '& a:last-child': {
        color: '#d73f32'
      }
    }
  },
  estornContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center'
  },
  paymentOptionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center'
  },
  voucher: {
    marginRight: '20px'
  },
  quantityContainer: {
    '& div:first-child': {
      marginBottom: '17px'
    },
    '& div:last-child': {
      fontSize: '12px',
      '& a': {
        cursor: 'pointer'
      },
      '& a:not(:last-child)': {
        color: '#30287b'
      }
    }
  }
})

export default MovieTicketsPurchases
